/**
 * @summary Contains the slider main area button navigation preact component.
 */

import { h, Component } from 'preact';

/**
 * @summary Slider button navigation preact component.
 *
 * @class
 * @extends {Component}
 */
export default class SliderMainButton extends Component {
	constructor( props ) {
		super( props );

		this.handleClick = this.handleClick.bind( this );
	}

	/**
	 * @summary Handles a click on this component.
	 *
	 * @listens document:click
	 *
	 * @param {MouseEvent} event The click event.
	 */
	handleClick( event ) {
		event.preventDefault();

		if ( typeof this.props.handleClick === 'function' ) {
			this.props.handleClick( this.props.direction );
		}
	}

	render({ direction }) {
		const classes = `c-slider__arrow c-slider__arrow--${direction}`;

		return <button class={classes} onClick={this.handleClick} />;
	}
};



// WEBPACK FOOTER //
// ./src/js/components/SliderMainButton.js